export default "__VITE_ASSET__BMdWetGn__"